import { render, staticRenderFns } from "./CustomerCategoryDiscountInfo.vue?vue&type=template&id=8b9e0cec&"
import script from "./CustomerCategoryDiscountInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerCategoryDiscountInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports